export default __webpack_public_path__ + "static/media/prophecies-preview.7cc4232d.png";